module.exports = __webpack_public_path__ + "images/aa-migration-wizard/illustration-main-mobile.96fd917d55a2c050023c.svg";